if (!customElements.get('g-localization-form')) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector('[data-localization-select]');
      select &&
        select.addEventListener('change', (e) => {
          const value = e.target.value;
          const form = select.closest('[data-localization-form]');
          const localeInput = form.querySelector('input[name="locale_code"]');
          const countryInput = form.querySelector('input[name="country_code"]');

          // 更新区域设置代码值
          if (localeInput) localeInput.setAttribute('value', value);
          if (countryInput) countryInput.setAttribute('value', value);

          // 获取当前 URL
          const currentUrl = new URL(window.location.href);

          // 获取路径部分并移除前后的斜杠
          let pathname = currentUrl.pathname.replace(/^\/|\/$/g, '');

          // 分割路径为数组
          let pathSegments = pathname.split('/');

          // 过滤掉语言代码部分
          pathSegments = pathSegments.filter(segment => !/^[a-z]{2}(-[a-z]{2})?$/i.test(segment));

          // 重新组合路径
          let updatedPathname = '/' + pathSegments.join('/');

          // 构建新的 URL
          currentUrl.pathname = updatedPathname;

          // 如果 locale 和 country 都是 EN，移除语言路径部分并跳转
          if (localeInput?.value.toUpperCase() === 'EN' && countryInput?.value.toUpperCase() === 'EN') {
            window.location.href = currentUrl.toString(); // 重新加载更新后的 URL
          } else {
            // 否则提交表单
            form.submit();
          }
        });
    }
  }
  customElements.define('g-localization-form', MLocalizationForm);
}
